import { HttpClient } from './HttpClient.js';


export const NoticeService = {

    async encriptar(form){
        return await HttpClient.get('/encriptacion/'+form).then(response => response);
    },

    async encriparTodos(usuarios){
        return await HttpClient.post('/notice/encript-users', usuarios).then(response => response)
    },

    

    /**
     * 
     * Estos son los servicios que usa el administrador
     */

    async getNoticesByAutor(idU){
        return await HttpClient.get(`/notice/get-notices-by-author/${idU}`).then(response => response)
    },

    async getNoticesByUser(idU){
        return await HttpClient.get(`/notice/get-notices-by-user/${idU}`).then(response => response)
    },   

    async getUsersByWorkplace(){
        return await HttpClient.get(`/user/get-by-dispatch`).then(response => response);
    },

    async saveNotice(form){
        return await HttpClient.post('/notice/post-create-notice',form).then(response => response);
    },

    async editNotice(id,form){
        return await HttpClient.post(`/notice/put-modify-notice/${id}`, form).then(response => response);
    },

    async deleteNotice(idA){
        return await HttpClient.delete(`/notice/delete-notice/${idA}`).then(response => response);
    },

    /**
    * 
    * Aqui van los servicios del supervisor
    */

    async getUsersBySupervisor(idSupervirsor){
        return await HttpClient.get('/notice/get-users-by-supervisor/'+idSupervirsor).then(response => response)

    }


    /**
    * 
    * Aqui van los servicios del gestor y colaborador
    */
}
